import { useEffect, useState } from "react";
import { url } from "../App";

const useGallery = () => {
    const [galleryItems, setGalleryItems] = useState([]);
    useEffect(() => {
        // GET request using fetch inside useEffect React hook
        fetch(`${url}/gallery/`)
            .then(response => response.json())
            .then(jsonData => {
                // console.log(jsonData);
                setGalleryItems(jsonData);
            });

        // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);
    return {
        galleryItems,
    };
};

export default useGallery;